import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { waitlistApi } from '../utils/waitlistApi';

const ShareSection = ({ referralCode }) => {
  const shareUrl = `${window.location.origin}?ref=${referralCode}`;
  const shareMessage = "¡Únete a DirectiveAI Metaverse y descubre una nueva forma de ver el mundo!";

  // Solo mantenemos WhatsApp:
  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${shareMessage}\n${shareUrl}`)}`,
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      alert('¡Enlace copiado al portapapeles!');
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  // Estilo e icono sólo para WhatsApp:
  const getSocialButtonStyle = (platform) => {
    if (platform === 'whatsapp') {
      return 'text-green-500 hover:bg-green-50';
    }
    return '';
  };

  const getSocialIcon = (platform) => {
    if (platform === 'whatsapp') {
      return (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      );
    }
    return null;
  };

  return (
    <div className="space-y-4">
      <div className="text-center space-y-2">
        <p className="text-sm text-gray-600">Comparte con tus amigos:</p>
        <div className="flex justify-center space-x-4">
          {/* Solo WhatsApp */}
          {Object.entries(shareLinks).map(([platform, url]) => (
            <a
              key={platform}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={`p-2 rounded-full transition-colors ${getSocialButtonStyle(platform)}`}
            >
              {getSocialIcon(platform)}
            </a>
          ))}
          {/* Botón para copiar link */}
          <button
            onClick={copyToClipboard}
            className="p-2 text-gray-600 hover:bg-gray-50 rounded-full transition-colors"
            title="Copiar enlace"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await waitlistApi.verifyEmail(token);
        setStatus('verified');
        setData(response);
      } catch (err) {
        setStatus('error');
        setError(err.message);
      }
    };
    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen bg-black">
      {/* Quitamos el logo de DirectiveAI */}
      <nav className="absolute top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          {/* Nav vacío */}
        </div>
      </nav>

      <div className="relative min-h-screen">
        <div className="absolute inset-0 overflow-hidden">
          <video
            className="w-full h-full object-cover"
            autoPlay
            loop
            muted
            playsInline
            src="/assets/videos/background.mp4"
          >
            Tu navegador no soporta video.
          </video>
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        </div>

        <div className="relative z-10 flex flex-col min-h-screen">
          <div className="flex-1 flex items-center justify-center px-4">
            <div className="bg-white rounded-lg p-8 max-w-md w-full">
              {status === 'verifying' && (
                <div className="text-center">
                  <h2 className="text-2xl font-bold mb-4">Verificando tu correo...</h2>
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-black mx-auto"></div>
                </div>
              )}

              {status === 'verified' && data && (
                <div className="text-center">
                  <div className="mb-6">
                    <h3 className="text-xl font-bold text-green-600 mb-2">
                      ¡Bienvenido a DirectiveAI!
                    </h3>
                    <p className="text-gray-600">
                      ¡Gracias por unirte! Comparte tu código de referido con tus amigos.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-lg mb-6 space-y-4">
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">
                        La persona con más invitaciones ganará un premio en efectivo.
                      </p>
                    </div>

                    <div className="bg-white p-4 rounded-md border border-gray-200">
                      <p className="text-sm text-gray-600 mb-2">Tu Código de Referido:</p>
                      <div className="flex items-center justify-center space-x-2">
                        {/* Forzamos el color de texto a negro */}
                        <code className="font-mono text-lg bg-gray-50 px-4 py-2 rounded border text-black">
                          {data?.referralCode}
                        </code>
                      </div>
                    </div>

                    <ShareSection referralCode={data?.referralCode} />
                  </div>

                  <button
                    onClick={() => (window.location.href = '/')}
                    className="w-full bg-gray-100 text-gray-700 py-2 rounded-md hover:bg-gray-200"
                  >
                    Volver a Inicio
                  </button>
                </div>
              )}

              {status === 'error' && (
                <div className="text-center">
                  <div className="mb-6">
                    <h3 className="text-xl font-bold text-red-600 mb-2">
                      Error en la verificación
                    </h3>
                    <p className="text-gray-600 mb-4">{error}</p>
                  </div>

                  <button
                    onClick={() => (window.location.href = '/')}
                    className="w-full bg-gray-100 text-gray-700 py-2 rounded-md hover:bg-gray-200"
                  >
                    Volver a Inicio
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="pb-8">
            <div className="mt-4 text-white/80 text-sm text-center">
              powered by DirectiveAI Inc.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
